import { LocationType } from "./Enums";

export class ScheduleDefaults {
	scheduleId: number = 0;
	locationType: LocationType = LocationType.Origin;
	locCode: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	commodityCode?: string = "";
}